import { GRADUATION_REQUIREMENTS_REVIEW } from '../../../api/endpoints';
import request from '../../../api/request';
import { actionKitImpFunction } from '../../../components/ozmoit/common';
import {
  PaginationQueryDto,
  PaginationRequestType,
} from '../../../types/paginationRequestType';
import {
  ElectiveRequirementEnrollmentStatus,
  ElectiveRequirementFilterData,
  ElectiveRequirementItem,
  ElectiveRequirementStudentRow,
  RecordRequirementResultPayload,
  RequirementStudentsFilters,
} from '../types';

const getElectiveRequirementsAction = actionKitImpFunction(
  async ({
    enrollmentStatus,
  }: {
    enrollmentStatus: ElectiveRequirementEnrollmentStatus;
  }) => {
    const response = await request<ElectiveRequirementItem[]>(
      GRADUATION_REQUIREMENTS_REVIEW.ELECTIVE_REQUIREMENTS,
      { params: { enrollmentStatus } },
    );
    if (response.error) {
      throw new Error('Error fetching elective requirements');
    }
    return response.data;
  },
);

const getRequirementFilterDataAction = actionKitImpFunction(
  async ({
    typeId,
    enrollmentStatus,
  }: {
    typeId: number;
    enrollmentStatus: ElectiveRequirementEnrollmentStatus;
  }) => {
    const response = await request<ElectiveRequirementFilterData>(
      GRADUATION_REQUIREMENTS_REVIEW.FILTER_DATA(typeId),
      { params: { enrollmentStatus } },
    );
    if (response.error) {
      throw new Error('Error fetching requirement filter data');
    }
    return response.data;
  },
);

const getRequirementStudentsAction = actionKitImpFunction(
  async ({
    typeId,
    page,
    ...params
  }: PaginationQueryDto<
    RequirementStudentsFilters & {
      typeId: number;
      enrollmentStatus: ElectiveRequirementEnrollmentStatus;
    }
  >) => {
    const response = await request<
      PaginationRequestType<ElectiveRequirementStudentRow>
    >(GRADUATION_REQUIREMENTS_REVIEW.STUDENTS(typeId), {
      params: {
        ...params,
        page: Math.max(page - 1, 0),
      },
    });
    if (response.error) {
      throw new Error('Error fetching requirement students');
    }
    return response.data;
  },
);

const recordRequirementResultAction = actionKitImpFunction(
  async ({
    typeId,
    studyPlanEnrollmentId,
    ...data
  }: RecordRequirementResultPayload & {
    typeId: number;
    studyPlanEnrollmentId: number;
  }) => {
    const response = await request<void>(
      GRADUATION_REQUIREMENTS_REVIEW.RECORD_RESULT(
        typeId,
        studyPlanEnrollmentId,
      ),
      { method: 'POST', data },
    );
    if (response.error) {
      throw new Error('Error recording requirement result');
    }
  },
);

const notifyRequirementResultAction = actionKitImpFunction(
  async ({
    typeId,
    studyPlanEnrollmentId,
  }: {
    typeId: number;
    studyPlanEnrollmentId: number;
  }) => {
    const response = await request<void>(
      GRADUATION_REQUIREMENTS_REVIEW.NOTIFY(typeId, studyPlanEnrollmentId),
      { method: 'POST' },
    );
    if (response.error) {
      throw new Error('Error notifying requirement result');
    }
  },
);

export {
  getElectiveRequirementsAction,
  getRequirementFilterDataAction,
  getRequirementStudentsAction,
  recordRequirementResultAction,
  notifyRequirementResultAction,
};
